
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {},
  name: 'BarcodeNotificationDialog',
  emits: ['update:modelValue', 'confirm', 'remove'],
})
export default class BarcodeNotificationDialog extends Vue {
  @Prop({ type: Boolean, required: true }) readonly modelValue!: boolean
  @Prop({ type: String, default: '' }) readonly message!: string
}
